import React from "react";
import { useTranslation } from "react-i18next";
import { useNavigate, useLocation } from "react-router-dom";

import { useAppDispatch } from "store/index";
import { closeModal } from "store/modals/slice";

import Button from "components/buttons/Button";
import { Modal } from "components/Modal/Modal";

const PremiumModal: React.FC = () => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  const handleCloseClick = () => {
    navigate(`${location.pathname}`);
    dispatch(closeModal());
  };

  return (
    <Modal onClose={handleCloseClick}>
      <Modal.Header />
      <Modal.Content>
        <div className="premium-modal-txt">
          Feature is available in premium mode with custom solutions.
        </div>
      </Modal.Content>
      <Modal.Footer>
        <Button
          isSecondary
          txt={t("cancel")}
          handleClick={handleCloseClick}
        />
      </Modal.Footer>
    </Modal>
  );
};

export default PremiumModal;
